import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { getTitle } from "../../../utils/KPIs/productionUtils";
import { Chart } from "primereact/chart";
import Loader from "../../../Base/Components/Loader/Loader";
import { decimalValueTemplate, formatNumber } from "../../../Base/Services/TemplatesServices";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { VentasPresMenAgents } from "../../../API/Ventas/ResumenVentasRequest";

const DialogChartAgentes = ({ date }) => {
  const { config } = useContext(ConfigContext);

  const [loading, setLoading] = useState(false);

  const colorTitle = getTitle(config);

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  const getInfo = async () => {
    setLoading(true);
    const tempoAgents = await VentasPresMenAgents({
      Anio: date.getFullYear(),
      Mes: date.getMonth() + 1,
    });
    const data = [...tempoAgents];
    const agentsNames = data.map((item) => item.AgenteVentas);

    let AmountT = [];
    let Kgs = [];
    let porcentaje = [];
    let totalAmountT = 0;

    // Primero, sumamos todo el AmountT para obtener el total
    tempoAgents.forEach((item) => {
      AmountT.push(item.AmountT);
      Kgs.push(item.Kgs);
      totalAmountT += item.AmountT;
    });


    porcentaje = AmountT.map((amount) => {
      return (amount / totalAmountT) * 100;
    });

    let Mes = date.toLocaleString("es-ES", { month: "long" });
    const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);

    const ID = data.map((item) => item.IdAgent);

    const predefinedColors = [
      "#ffa170",
      "#FFA0B4",
      "#f5e586",
      "#82CDFF",
      "#8861ff",
      "#9dc09d",
      "#9e6788",
      "#FF5733",
      "#20c67a",
      "#33A1FF",
    ];

    const labelsWithColor = tempoAgents.map((item) => {
      return `${
        item.AgenteVentas + " (" + "$ " + formatNumber(item.AmountT) + ")"
      }`;
    });

    const data1 = {
      labels: labelsWithColor,
      datasets: [
        {
          label: "AmounT",
          backgroundColor: predefinedColors,
          data: AmountT,
          data2: porcentaje,
          data3: Kgs,
          data4: agentsNames
        },
      ],
    };
    const options = {
      interaction: {
        intersect: true,
        mode: "index",
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: `Ventas por agente - ` + monthName + " / " + date.getFullYear(),
          color: colorTitle,
          padding: {
            top: 5,
            bottom: 50,
          },
          font:{
            size:15,
            weight: 'bold'
          }
        },
        datalabels: {
            borderRadius: 4,
            align: 'end',
            offset: 50,
            arrowWidth: 10,
            arrowHeight: 10,
            padding: 6,
            color: colorTitle,
            formatter: function (values,context) {
                const index = context?.dataIndex;
                const agent = context?.dataset?.data4[index]
                const valor = context?.dataset?.data[index];
                return `${agent} \nVentas: $ ${decimalValueTemplate(valor)}`;
            },
            display: function (context) {
                const index = context?.dataIndex;
                const porcentaje = context?.dataset?.data2[index];
                return porcentaje >= 5; // mostrar solo si el porcentaje es >= 5%
            },
            font: {
                weight: 'bold',
                size:11
            },
        },
        aspectRatio: 5 / 3,
        elements: {
          line: {
            fill: false,
            tension: 0.4,
          },
        },
        legend: {
          display: true,
          position: "right",
          labels: {
            color: colorTitle,
            font: {
              size: 11,
              weight: 'bold'
            },
          },
        },
        tooltip: {
          callbacks: {
            footer: (tooltipItems) => {
              const index = tooltipItems[0].dataIndex;
              const valor = tooltipItems[0]?.dataset?.data2[index];
              const kgs = tooltipItems[0]?.dataset?.data3[index];
              return `Kgs: ${formatNumber(kgs)} kgs \nPorcentaje: ${decimalValueTemplate(valor)} %`;
            },
          },
        },
      },
    };

    setChartData(data1);
    setChartOptions(options);
    setLoading(false);
  };

  useEffect(() => {
    if (date) {
      getInfo();
    }
  }, [date]);

  return (
    <div id="agentsLoading">
      <Loader loading={loading} querySelector={"#agentsLoading"} />
      <Chart
        type="pie"
        height={"400px"}
        width="100%"
        data={chartData}
        options={chartOptions}
        plugins={[ChartDataLabels]}
      />
    </div>
  );
};

export default DialogChartAgentes;
